"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoginLink = _ref => {
  let {
    loginPath
  } = _ref;
  return !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && window.location.pathname !== loginPath && /*#__PURE__*/_react.default.createElement("span", {
    className: "navbar-item login-link"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: loginPath,
    className: "button is-info has-text-white is-small is-uppercase has-text-weight-bold"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icons mr-1 is-size-3 is-unselectable"
  }, "lock"), `${_ApplicationContext.ApplicationContext.getSiteTitle()} Login`));
};
LoginLink.propTypes = {
  loginPath: _propTypes.default.string
};
LoginLink.defaultProps = {
  loginPath: _ApplicationContext.ApplicationContext.getLoginPath()
};
var _default = exports.default = LoginLink;
//# sourceMappingURL=LoginLink.js.map